import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c59ac868"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "ID дашборда в DataLens", -1))
const _hoisted_3 = { class: "flex flex-col m-t-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название", -1))
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Организация", -1))
const _hoisted_7 = { class: "flex flex-col m-t-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Автор", -1))
const _hoisted_9 = { class: "flex flex-col m-t-8" }
const _hoisted_10 = { class: "toggle-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "include_demo",
  class: "small-label"
}, "Включать в список воркбуки демо-аккаунтов", -1))
const _hoisted_12 = { class: "flex flex-col m-t-8" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата создания", -1))
const _hoisted_14 = { class: "flex flex-col m-t-8" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Дата редактирования", -1))
const _hoisted_16 = { class: "flex flex-col m-t-8" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Добавляются в демо-аккаунты при создании", -1))
const _hoisted_18 = { class: "fl m-b-8 m-t-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "include_to_demo_accounts_yes",
  class: "p-l-4"
}, "Да", -1))
const _hoisted_20 = { class: "fl" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "include_to_demo_accounts_no",
  class: "p-l-4"
}, "Нет", -1))

import InputText from "primevue/inputtext";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import InputSwitch from "primevue/inputswitch";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkbookFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const initialFilter = {
  name: "",
  datalens_id: "",
  cdate: null,
  mdate: null,
  user: [] as number[],
  organization: [] as number[],
  include_demo: false,
  include_to_demo_accounts: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter
  }, {
    fields: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(InputText), {
          placeholder: "Введите значение",
          modelValue: slotProps.filter.datalens_id,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.datalens_id) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(InputText), {
          placeholder: "Введите название",
          modelValue: slotProps.filter.name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "organization",
          isSegmentSetted: false,
          modelValue: slotProps.filter.organization,
          "onUpdate:modelValue": 
            ($event) => (slotProps.filter.organization = $event)
          
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "user",
          isSegmentSetted: false,
          modelValue: slotProps.filter.user,
          "onUpdate:modelValue": ($event) => (slotProps.filter.user = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(InputSwitch), {
            modelValue: slotProps.filter.include_demo,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.include_demo) = $event),
            inputId: "include_demo"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.cdate,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.cdate) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_unref(Calendar), {
          id: "date",
          panelClass: "not-extended",
          placeholder: "Выберите значение",
          modelValue: slotProps.filter.mdate,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.mdate) = $event),
          "aria-describedby": "date-help",
          showIcon: "",
          iconDisplay: "input",
          inputId: "icondisplay"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.include_to_demo_accounts,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.include_to_demo_accounts) = $event),
            inputId: "include_to_demo_accounts_yes",
            name: "include_to_demo_accounts",
            value: "1"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.include_to_demo_accounts,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.include_to_demo_accounts) = $event),
            inputId: "include_to_demo_accounts_no",
            name: "include_to_demo_accounts",
            value: "0"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_21
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})